import React from 'react';
import { AwardIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { productBrand, productEdition, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="border-y border-slate-800 bg-slate-900/50 py-16 sm:py-20" aria-labelledby="system-title" data-id="element-188" data-mp="3bhbu9hm7k3fw">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-189" data-mp="36lwjiyjhynnp">
        <span className="inline-flex items-center gap-2 rounded-full border border-amber-400/50 bg-slate-950 px-4 py-2 text-xs font-extrabold uppercase tracking-[.12em] text-white" data-id="element-190" data-mp="31lqwxws33rch">
          <AwardIcon className="h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" data-id="element-191" data-mp="2srvp2gzkvmt5" /> Il sistema didattico più completo di Geologia per docenti
        </span>
        <SectionHeading id="system-title" className="mt-6" data-id="element-192" data-mp="2nr7tdi0emhsl">
          {productBrand} — <span className="text-amber-400" data-id="element-193" data-mp="2itptsi8a1ex9">{productEdition}</span>
        </SectionHeading>
        <p className="mt-4 font-semibold text-slate-300" data-id="element-194" data-mp="2dwfsa47m5ct2">
          {totalVolumes} volumi · {totalBonuses} bonus esclusivi
        </p>

        <p className="mx-auto mt-10 flex max-w-3xl items-start gap-3 rounded-2xl border border-slate-800 bg-slate-950 p-6 text-left text-lg font-semibold leading-relaxed text-white shadow-lg shadow-black/40" data-id="element-195" data-mp="13xdanpln4kj7">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-orange-400" aria-hidden="true" data-id="element-196" data-mp="z04t9r8bgkj0" />
          Un sistema didattico completo per insegnare come funziona la Terra: dalla struttura interna del pianeta ai minerali
          e alle rocce, dalla tettonica delle placche ai terremoti e ai vulcani, fino agli strati, ai fossili, alle carte
          geologiche e alla geologia applicata all&apos;ambiente e alle risorse. Con attività, progetti e verifiche pronti per
          la classe.
        </p>
      </div>
    </section>;
}